import "jquery-validation";
import "jquery-validation-unobtrusive";
import 'bootstrap/js/dist/scrollspy';
import "bootstrap/js/dist/modal";
import GLightbox from 'glightbox';
import React from "react";
import ReactDOM from "react-dom";
import { LessonCounter } from "./components/lesson-counter";
import { dataSetToProps } from "../../library/tools";

GLightbox({ selector: '[data-glightbox]' });

$("body").scrollspy({ target: '#detail-nav' });

//$(".profile-video").each(function () {
//    var $profileVideo = $(this);
//    var $video = $profileVideo.find("video");
//    var $btnPlay = $profileVideo.find(".btn-play");
//    $btnPlay.click(function () {
//        if ($video.data("playStatus") === 1) {
//            $video[0].pause();
//            $video.data("playStatus", 0);
//        } else {
//            $video[0].play();
//            $video.data("playStatus", 1);
//        }
//    });
//});

const lessonCounterRootElements = document.querySelectorAll(".lesson-counter-root");
for (let lessonCounterRootElement of lessonCounterRootElements) {
    ReactDOM.render(
        <LessonCounter {...dataSetToProps(lessonCounterRootElement.dataset)} />,
        lessonCounterRootElement
    );

}
